import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";
import type { Notification } from "./NotificationContext";
import { NotificationContext } from "./NotificationContext";

export const NotificationContextProvider = (props: PropsWithChildren) => {
  const [notification, setNotification] = useState<Notification>();
  const [notificationError, setNotificationError] = useState<Notification>();

  const sendNotification = useCallback(
    (text: string, autoHideDuration = 6000) => {
      setNotification({ text, autoHideDuration });
    },
    [setNotification]
  );

  const sendNotificationError = useCallback(
    (text: string, autoHideDuration = 10000) => {
      setNotificationError({ text, autoHideDuration });
    },
    [setNotificationError]
  );

  const onCloseNotification = useCallback(() => {
    setNotification(undefined);
  }, []);

  const onCloseNotificationError = useCallback(() => {
    setNotificationError(undefined);
  }, []);

  return (
    <NotificationContext
      value={{
        notification,
        notificationError,
        sendNotification,
        sendNotificationError,
        onCloseNotification,
        onCloseNotificationError,
      }}
    >
      {props.children}
    </NotificationContext>
  );
};
